import { DeliveryAndReturnContentItem, DeliveryAndReturnContentKey } from 'types/Product';
import { VDPSKU } from 'types/VDPTypes';
import getOnePersonHtml from './onePersonHtmlGenerator';
import getTwoPersonHtml from './twoPersonHtmlGenerator';
import getMidRangeHtml from './midRangeHtmlGenerator';
import getFfmHtml from './ffmHtmlGenerator';

const vdpDeliveryContent = (
  contentKey: DeliveryAndReturnContentKey | undefined,
  sku: string | undefined,
  vdpSkus: Array<VDPSKU> | undefined,
  site: string | undefined,
  brand?: string,
): DeliveryAndReturnContentItem | string => {
  const deliveryPrices = vdpSkus?.find((item: any) => item.id === sku)?.attributes.deliveryPrices ?? [];

  switch (contentKey) {
    case 'OnePerson':
      return getOnePersonHtml(site, deliveryPrices);
    case 'TwoPerson':
      return getTwoPersonHtml(site, deliveryPrices);
    case 'MidRange':
      return getMidRangeHtml(site, deliveryPrices);
    case 'FFM':
      return getFfmHtml(site, deliveryPrices, brand ?? '');
    default:
      return '';
  }
};

export default vdpDeliveryContent;
